import { useConfig } from '@Src/providers/ConfigProvider';
import { useLogger } from '@Src/providers/LoggerProvider';
import Cookies from 'js-cookie';

const baseUrl = 'https://api.flipdish.co';

interface ApiResponse<T> {
  error?: boolean;
  errorMessage?: string;
  errorStack?: string;
  data?: T;
}

type StringWithSlashType = `/${string}`;

type SupportedMethodsType = {
  post: <B, R>(
    path: StringWithSlashType,
    payload?: B,
  ) => Promise<ApiResponse<R>>;
  get: <R>(path: StringWithSlashType) => Promise<ApiResponse<R>>;
};

export const useApi = (): SupportedMethodsType => {
  const logger = useLogger();
  const { appId, version } = useConfig();
  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Photon',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
    'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
  };
  return {
    post: async <B, R>(
      path: StringWithSlashType,
      payload?: B,
    ): Promise<ApiResponse<R>> => {
      try {
        const data = await fetch(`${baseUrl}${path}`, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers,
        });

        const response = await data.json();
        return { data: response };
      } catch (e: any) {
        logger.error(`Failed to fetch ${path}`, {
          payload: { payload },
          error: e,
          errorMessage: e.message,
          errorStack: e.stack,
        });
        return {
          error: true,
          errorMessage: e.message,
          errorStack: e.stack,
        };
      }
    },
    get: async <R>(path: StringWithSlashType): Promise<ApiResponse<R>> => {
      try {
        const data = await fetch(`${baseUrl}${path}`, {
          method: 'GET',
          headers,
        });

        const response = await data.json();
        return { data: response };
      } catch (e: any) {
        // logger.error(`Failed to fetch ${path}`, {
        //   error: e,
        //   errorMessage: e.message,
        //   errorStack: e.stack,
        // });
        return {
          error: true,
          errorMessage: e.message,
          errorStack: e.stack,
        };
      }
    },
  };
};

export default useApi;
